// Display mirror of backend/src/lib/soaApproval.ts: what counts while an SOA edit waits for the consultant.
// An entry pending approval (approvalStatus DRAFT) is shown with its pending value and the "Pending approval" tag,
// but every figure (score, counts, bars) uses the last approved values, as the server does.

export interface SoaApprovalEntry {
  status: string;
  applicable?: boolean | null;
  justification?: string | null;
  approvalStatus?: string | null;
  approvedStatus?: string | null;
  approvedApplicable?: boolean | null;
  approvedJustification?: string | null;
  rejectionReason?: string | null;
  rejectedAt?: string | null;
}

export function approvedView(e: SoaApprovalEntry): { status: string; applicable: boolean | null; justification: string | null } {
  if (e.approvalStatus !== "DRAFT") return { status: e.status, applicable: e.applicable ?? null, justification: e.justification ?? null };
  return { status: e.approvedStatus ?? "NOT_STARTED", applicable: e.approvedApplicable ?? null, justification: e.approvedJustification ?? null };
}

const STATUS_NAMES: Record<string, string> = { COMPLIANT: "Compliant", IN_PROGRESS: "In progress", GAP: "Gap", NOT_STARTED: "Not started" };
export function soaStatusName(status: string | null | undefined): string {
  return status ? (STATUS_NAMES[status] ?? status.toLowerCase().replace(/_/g, " ")) : "Not started";
}
export function soaApplicabilityName(applicable: boolean | null | undefined): string {
  return applicable === true ? "Applicable" : applicable === false ? "Not applicable" : "Not yet decided";
}

/** What a client is told about their own pending change (mirror of pendingChangeMessage on the server). */
export function pendingChangeText(e: SoaApprovalEntry): string {
  const approved = approvedView(e);
  if (e.applicable === false && approved.applicable !== false) return "Your consultant will review this exclusion; the control stays in your score until they approve it";
  if (e.status !== approved.status) return "Your consultant will review and confirm this status; your score changes once they approve it";
  return "Your consultant will review this note";
}
